import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-leaving-site-warning-modal',
  template: `
    <div
      #modal
      class="container"
      (click)="close()"
      (keyup.enter)="close()"
      tabindex="0"
    >
      <div
        class="content"
        (click)="$event.stopPropagation()"
        (keyup.enter)="$event.stopPropagation()"
        tabindex="0"
      >
        <h2>Notice</h2>
        <p>
          You are leaving our site and we cannot be held responsible for the
          content of external websites.
        </p>
        <div class="buttons-container">
          <button (click)="close()">Cancel</button>
          <button class="primary" (click)="continue()">Continue</button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./leaving-site-warning-modal.component.scss'],
})
export class LeavingSiteWarningModalComponent {
  faQuestionCircle = faQuestionCircle;
  showDropdown: boolean = undefined;

  @ViewChild('modal', { static: false }) modal: ElementRef;

  @Output() leaveSiteConfirmed = new EventEmitter<boolean>();

  open() {
    this.modal.nativeElement.style.display = 'block';
  }

  close() {
    this.modal.nativeElement.style.display = 'none';
  }

  continue() {
    this.leaveSiteConfirmed.emit(true);
  }
}
